import SecureLS from 'secure-ls';

const ls =
  typeof window !== 'undefined'
    ? new SecureLS({ encodingType: 'aes', isCompression: true })
    : {
        set: () => ({}),
        get: () => ({}),
        remove: () => ({}),
      };

export default ls;
